module.exports = __webpack_public_path__ + "assets/70ff3716a53fc0460e15db58615de6dd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/DASS/DASS01.mp3
 ** module id = 210
 ** module chunks = 0
 **/